import { createSlice } from '@reduxjs/toolkit';

export interface ExLog {
  content: string;
  isError: boolean;
};

export type ExLogArray = Array<ExLog>;

const initialState: ExLogArray = [];

const exLogSlice = createSlice({
  name: 'exLog',
  initialState,
  reducers: {
    addExLog: (state, action) => {
      state.push(action.payload);
    },
    deleteExLog: (state) => {
      state = [];
      return state;
    }
  },
});

export const { addExLog, deleteExLog } = exLogSlice.actions;

export default exLogSlice.reducer;